
// custom widgets JS...
const analytics_option_list = document.querySelectorAll('.grootapps_analys-opt-col');
const analyticsAccordionImages = document.querySelectorAll('.grootapps_analys-accordion-image');
const analyticsAccordionIconWrappers = document.querySelectorAll('.grootapps_analys-acoordion-icon-wrap');

// click event..
if (window.innerWidth <= 991) {
    

    if (analytics_option_list.length > 0) {
        const firstOption = analytics_option_list[0];
        const firstAccordionImg = analyticsAccordionImages[0];
        const firstIconWrapper = analyticsAccordionIconWrappers[0];
        const firstIconImg = firstIconWrapper?.querySelector('img');
        const minusImg = firstIconWrapper?.dataset.minusimg;
    
        firstOption.classList.add('active');
        firstAccordionImg.classList.add('active');
    
        if (firstIconImg && minusImg) {
            firstIconImg.src = minusImg;
        }
    
        // add click event to all options..
        analytics_option_list.forEach((option, index) => {
            option.addEventListener('click', function () {
                const currentAnalyImg = analyticsAccordionImages[index];
                const currentAnalyIconWrapper = analyticsAccordionIconWrappers[index];
                const currentAnalyIconImg = currentAnalyIconWrapper?.querySelector('img');
                const minusImg = currentAnalyIconWrapper?.dataset.minusimg;
        
                const isActive = option.classList.contains('active');
        
                // first close all..
                analyticsAccordionImages.forEach((img, i) => {
                img.classList.remove('active');
                analytics_option_list[i].classList.remove('active');
        
                const iconImg = analyticsAccordionIconWrappers[i]?.querySelector('img');
                const plusImg = analyticsAccordionIconWrappers[i]?.dataset.plusimg;
                if (iconImg && plusImg) {
                    iconImg.src = plusImg;
                }
                });
        
                // if it was NOT active, open it..
                if (!isActive) {
                    if (currentAnalyImg) currentAnalyImg.classList.add('active');
                    option.classList.add('active');
                    if (currentAnalyIconImg && minusImg) currentAnalyIconImg.src = minusImg;
                }
            });
        });
    }

}